export default __webpack_public_path__ + "static/media/heroimg.b1150f53.png";